import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Models
import { attributes } from 'models/entity';
import mInstallation from 'models/installation';
// Custom
import { entityDataShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';
import EntityIcon from './EntityIcon';

const EntitySelectFieldFilter = ({ entityId, entities, onChange }) => (
  <ResourceSelectFieldFilter
    labelId="field.entity"
    resourceId={entityId}
    resources={
      _map(entities, (entity) => ({
        ...entity,
        itemCustomIcon: <EntityIcon entity={entity} />,
      }))
    }
    displayKey={
      (entity) => {
        const { isMaster, hostsOneparkBookings, name } = attributes(entity);
        return (
          <LocalizedMessage
            id="info.installationEntityName"
            values={{ isMaster, hostsOneparkBookings, name }}
          />
        );
      }
    }
    onChange={onChange}
  />
);

EntitySelectFieldFilter.propTypes = {
  entityId: PropTypes.number,
  entities: PropTypes.arrayOf(entityDataShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

EntitySelectFieldFilter.defaultProps = {
  entityId: null,
};

const mapStateToProps = (state) => ({
  entities: mInstallation.sortedEntities(state.installation.current.data),
});

module.exports = connect(
  mapStateToProps,
  null,
)(EntitySelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/entities/EntitySelectFieldFilter.js